import DashboardLayout from "../../layout/Layout";

const Dashboard = () => {
  return <DashboardLayout title="Dashboard"></DashboardLayout>;
};

export default Dashboard;
